import React from "react";
import { FaClockRotateLeft, FaXmark } from "react-icons/fa6";

import { plateNumberFormatter } from "../../formatters";

interface PlateNumberInputProps {
  onChanged: (value: string) => void;
  history: string[];
  onHistoryRemove: (entry: string) => void;
  onHistorySelect: (value: string) => void;
}

const PlateNumberInput: React.FC<PlateNumberInputProps> = ({
  onChanged,
  history,
  onHistoryRemove,
  onHistorySelect,
}) => {
  const [value, setValue] = React.useState<string>("");
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    onChanged(value);
  }, [value, onChanged]);

  const handlePlateNumberChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const formatted = plateNumberFormatter(e.target.value);
    setValue(formatted);
  };

  const handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    const { currentTarget, relatedTarget } = event;
    if (relatedTarget && currentTarget.contains(relatedTarget as Node)) {
      return;
    }
    setIsFocused(false);
  };

  return (
    <div onFocus={() => setIsFocused(true)} onBlur={handleBlur} className="relative w-full max-w-md" tabIndex={-1}>
      <input
        autoFocus
        value={value}
        onChange={handlePlateNumberChange}
        placeholder="0000AAA"
        className="w-full bg-card text-primary placeholder:text-muted-foreground text-center font-bold text-shadow-lg text-[2rem] leading-10 p-3 rounded-xl"
        required
        minLength={7}
        maxLength={7}
      />
      {isFocused && history.length > 0 && (
        <div className="absolute z-10 left-0 right-0 mt-2 p-2 bg-white text-[#595959] rounded-lg text-[1.125rem] leading-4.5">
          {history.map((entry) => (
            <div key={entry} className="flex items-stretch gap-2 hover:bg-[#595959]/10 rounded-lg">
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onHistorySelect(entry)}
                className="flex-1 flex items-center gap-3 text-left p-2 pr-0"
              >
                <FaClockRotateLeft />
                <span>{entry}</span>
              </button>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => onHistoryRemove(entry)}
                className="p-3 hover:bg-[#595959]/10 rounded-lg"
              >
                <FaXmark />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PlateNumberInput;
